import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'math-not', 'MathNot', [["path",{"d":"M5 12h14v4","key":"svg-0"}]]);